import { render, staticRenderFns } from "./news.vue?vue&type=template&id=5eedab0f&scoped=true&"
import script from "./news.vue?vue&type=script&scoped=true&lang=js&"
export * from "./news.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=5eedab0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eedab0f",
  null
  
)

export default component.exports